import { useState, useCallback, useRef } from "react";
import { ref, get } from "firebase/database";

import { rtdb } from "../services/firebase";
import { useAuth } from "../context/AuthContext";
import {
    buildWholesaleCartWhatsAppMessage,
    openWhatsApp,
} from "../utils/whatsapp";

/**
 * @param {{ title: string, flavor: string, quantity: number }[] | undefined} presetItems
 */
export default function useWholesaleWhatsApp(presetItems) {
    const { cart } = useAuth();
    const [loading, setLoading] = useState(false);
    const loadingRef = useRef(false);

    const openWholesaleWhatsApp = useCallback(async () => {
        if (loadingRef.current) return;

        loadingRef.current = true;
        setLoading(true);
        try {
            let lines = [];

            if (presetItems && presetItems.length > 0) {
                lines = presetItems.map(({ title, flavor, quantity }) => ({
                    title,
                    flavor,
                    quantity,
                }));
            } else if (cart.length > 0) {
                const resolved = await Promise.all(
                    cart.map(async (item) => {
                        const snap = await get(ref(rtdb, `products/${item.productId}`));
                        const title = snap.exists() ? snap.val().nome : item.productId;
                        return {
                            title,
                            flavor: item.flavor,
                            quantity: item.quantity,
                        };
                    })
                );
                lines = resolved.filter(Boolean);
            }

            openWhatsApp(buildWholesaleCartWhatsAppMessage(lines));
        } catch (err) {
            console.error("Erro ao abrir WhatsApp de atacado:", err);
        } finally {
            loadingRef.current = false;
            setLoading(false);
        }
    }, [cart, presetItems]);

    return { openWholesaleWhatsApp, loading };
}
